import Button from '../Button/Button';
import { UploadIcon } from './DocumentIcons';
import styles from './Documents.module.scss';

export default function UploadBox({
  title,
  hint,
  onUpload,
  uploading,
  compact,
}: {
  title: string;
  hint: string;
  onUpload: () => void;
  uploading: boolean;
  /** One row instead of the tall centered box. */
  compact?: boolean;
}) {
  return (
    <div className={`${styles.uploadBox} ${compact ? styles.uploadCompact : ''}`}>
      <span className={styles.uploadIcon}>
        <UploadIcon />
      </span>
      <span className={styles.uploadMeta}>
        <span className={styles.uploadTitle}>{title}</span>
        <span className={styles.uploadHint}>{hint}</span>
      </span>
      <Button variant="green" size="sm" onClick={onUpload} disabled={uploading}>
        {uploading ? 'Uploading…' : 'Upload PDF'}
      </Button>
    </div>
  );
}
